// extracted by mini-css-extract-plugin
export var deleteModal = "_gg-0";